import { ZodSchema } from "@validation/utils/schemaUtils";
import z from "zod";

export const connectingVesselSchema = z.object({
	id: z.number().nullable(),
	name: z.string().min(1).max(75),
	mmsi: ZodSchema.requiredField(z.number().min(100000000).max(999999999)),
	imo: ZodSchema.requiredField(z.number().min(1000000).max(9999999)),
	callSign: z.string().min(1).max(10),
	flagName: z.string().min(1).max(15),
	flagCode: z.string().min(1).max(15),
	tracking: z.boolean(),
});

export const connectingVesselSelectSchema = z.object({
	id: z.number(),
	name: z.string(),
});

export type ConnectingVesselSchemaInput = z.input<typeof connectingVesselSchema>;
export type ConnectingVesselSchemaOutput = z.output<typeof connectingVesselSchema>;
